import script from "./TipTapEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TipTapEditor.vue?vue&type=script&setup=true&lang=js"

import "./TipTapEditor.vue?vue&type=style&index=0&id=187721a8&lang=css"

const __exports__ = script;

export default __exports__